// extracted by mini-css-extract-plugin
export default {"tableContainer":"AdminsTable_tableContainer__Z1oGA","userCellContainer":"AdminsTable_userCellContainer__0qkbI"};